import { FileUpload } from '../models/file-upload';
import { Logger } from '../models/logger';

export class ConvertOptionsUtils {

    public static hasProperty(fileUpload: FileUpload, property: string) {
        try {
            return !!fileUpload.options.find(i => i.formName === property);
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }

    public static getPropertyValue(fileUpload: FileUpload, property: string) {
        try {
            return fileUpload.options.find(i => i.formName === property).formValue;
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }

    public static getSubPropertyValue(subpropertyValue: any, property: string) {
        try {
            return subpropertyValue.find(i => i.formName === property).formValue;
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find property, ${property} on subproperty value`);
        }
    }

    public static hasPropertyWithValue(fileUpload: FileUpload, property: string, value: string) {
        try {
            const object = fileUpload.options.find(i => i.formName === property);
            return object.formValue === value;
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }
}
